"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TierSummaryWidget = void 0;
var React = require("react");
var commonFunctions_1 = require("../../../commonFunctions");
var core_1 = require("@athena-portal/core");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var services_1 = require("@falcon/services");
var AggregatorReferenceWidget_1 = require("../common/AggregatorReferenceWidget");
var TierSummaryWidget = exports.TierSummaryWidget = /** @class */ (function (_super) {
    __extends(TierSummaryWidget, _super);
    function TierSummaryWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.previousPremium = 0;
        if (_this.props.interaction.product === services_1.PRODUCT_WOLF_MOTOR) {
            _this.previousPremium = _this.props.interaction.factors.premiumType === services_1.PREMIUM_TYPE_ANNUAL ?
                _this.props.interaction.factors.annualPremium : _this.props.interaction.paymentDetails.instalmentPlan.monthlyPayment;
        }
        return _this;
    }
    TierSummaryWidget.prototype.getSelectedTierName = function () {
        var tierName = "";
        switch (this.props.interaction.coverTier) {
            case services_1.MotorCoverTier.ALLIANZ_ESSENTIALS:
                tierName = "allianz-essentials-tier";
                break;
            case services_1.MotorCoverTier.ALLIANZ_SILVER:
                tierName = "allianz-silver-tier";
                break;
            case services_1.MotorCoverTier.ALLIANZ:
                tierName = "allianz-tier";
        }
        return tierName;
    };
    TierSummaryWidget.prototype.render = function () {
        var _a;
        var monthlyPremium = (_a = this.props.interaction.paymentDetails.instalmentPlan) === null || _a === void 0 ? void 0 : _a.monthlyPayment;
        var annualPremium = this.props.interaction.factors.annualPremium;
        var premiumType = this.props.interaction.factors.premiumType;
        var premiumToDisplay = (this.props.interaction.factors.premiumType === services_1.PREMIUM_TYPE_ANNUAL)
            ? (annualPremium === 0) ? this.previousPremium : annualPremium
            : (monthlyPremium === 0) ? this.previousPremium : monthlyPremium;
        this.previousPremium = premiumToDisplay;
        var tierName = this.getSelectedTierName();
        var isNotPendingMta = this.props.interaction.status != services_1.INTERACTION_STATUS_PENDING_MTA;
        return (React.createElement("div", { className: "tier-summary-container" },
            isNotPendingMta && React.createElement(AggregatorReferenceWidget_1.AggregatorReferenceWidget, { source: this.props.interaction.source }),
            React.createElement("div", { className: "tier-summary-widget w-100" },
                React.createElement("div", { className: "d-flex justify-content-between heading-row pb-4" },
                    React.createElement("img", { src: "/".concat(services_1.resourcesHelper.THEME, "/img/").concat(tierName, ".svg"), alt: "Tier logo" }),
                    React.createElement("h2", { className: "mt-3 tier-premium" },
                        (0, commonFunctions_1.getAmountToDisplay)(premiumToDisplay),
                        this.props.interaction.factors.premiumType === services_1.PREMIUM_TYPE_ANNUAL
                            ? React.createElement("span", { className: "premium-type" }, "/ year*")
                            : React.createElement("span", { className: "premium-type" }, "/ month*"))),
                this.renderCarsDetails(),
                this.renderDrivers(),
                React.createElement("div", null, "Comprehensive cover, underwritten by Liverpool Victoria Insurance Company Limited, which is an Allianz Group company"),
                React.createElement("div", null,
                    "* All figures include ",
                    premiumType === services_1.PREMIUM_TYPE_ANNUAL ? 'Insurance Premium Tax' : 'Interest and Insurance Premium Tax'))));
    };
    TierSummaryWidget.prototype.renderCarsDetails = function () {
        var _this = this;
        var vehicles = this.props.interaction.vehicles;
        return vehicles.map(function (vehicle, index) { return (React.createElement("div", { key: index, className: "mb-4" },
            React.createElement("div", null, "".concat(vehicle.make, ", ").concat(vehicle.model),
                " (",
                vehicle.registrationNumber,
                ")"),
            React.createElement("div", null, "".concat(_this.fetchLookupValue("carUsage", vehicle.classOfUse))),
            React.createElement("div", { className: "mt-2 edit-car-link d-flex" },
                React.createElement("a", { className: "white-link", onClick: function () { return _this.editCarDetails(index); } }, "Edit car details")))); });
    };
    TierSummaryWidget.prototype.renderDrivers = function () {
        var _a;
        var _this = this;
        var vehicle = this.props.interaction.vehicles[0];
        var allDrivers = [this.props.interaction.policyHolder].concat(this.props.interaction.additionalDrivers || []);
        var vehicleDrivers = (0, commonFunctions_1.getVehiclePermanentDrivers)(vehicle, allDrivers);
        var mainDriver = (_a = (0, commonFunctions_1.getVehicleRealMainDriverAndAdditionalDrivers)(vehicleDrivers, vehicle.mainDriverId), _a.mainDriver), additionalDrivers = _a.additionalDrivers;
        return (React.createElement("div", { className: "mb-4" },
            React.createElement("div", null,
                React.createElement("div", null,
                    mainDriver.firstName,
                    " ",
                    mainDriver.lastName,
                    " (main driver)"),
                React.createElement("div", { className: "mt-2 edit-driver-link d-flex" },
                    React.createElement("a", { className: "white-link", onClick: function () { return _this.editMainDriver(); } }, "Edit driver"))),
            this.renderAdditionalDrivers(additionalDrivers),
            React.createElement("div", { className: "mt-2 d-flex" },
                React.createElement("i", { className: "fa fa-plus d-flex align-items-center" }),
                React.createElement("a", { className: "white-link", onClick: function () { return _this.addDriver(); } }, "Add another driver"))));
    };
    TierSummaryWidget.prototype.renderAdditionalDrivers = function (vehicleAdditionalDrivers) {
        var _this = this;
        if (vehicleAdditionalDrivers.length > 0) {
            return vehicleAdditionalDrivers.map(function (driver, index) { return (React.createElement("div", { key: index, className: "mt-3" },
                React.createElement("div", null,
                    driver.firstName,
                    " ",
                    driver.lastName),
                React.createElement("div", { className: "mt-2 edit-driver-link d-flex" },
                    React.createElement("a", { className: "white-link", onClick: function () { return _this.editAdditionalDriver(index); } }, "Edit driver")))); });
        }
        else {
            return React.createElement(React.Fragment, null);
        }
    };
    TierSummaryWidget.prototype.fetchLookupValue = function (fieldId, id) {
        var value = "";
        this.lookupService.fetchLookupValues(fieldId, "en-UK").subscribe(function (lookupValues) {
            var _a, _b;
            value = (_b = (_a = lookupValues === null || lookupValues === void 0 ? void 0 : lookupValues.find(function (entry) { return entry.id === id; })) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : "";
        });
        return value;
    };
    TierSummaryWidget.prototype.editCarDetails = function (vehicleIndex) {
        if (vehicleIndex === 0) {
            this.props.engine.navigate("numberPlateScan", false);
        }
        else {
            this.props.engine.navigate("additionalVehicle".concat(vehicleIndex, "RegistrationNumberPage"), false);
        }
    };
    TierSummaryWidget.prototype.editMainDriver = function () {
        this.props.engine.navigate("drivingLicenceScan", false);
    };
    TierSummaryWidget.prototype.editAdditionalDriver = function (driverIndex) {
        this.props.engine.navigate("editAdditionalDriver".concat(driverIndex + 1, "DrivingLicenceScanPage"), false);
    };
    TierSummaryWidget.prototype.addDriver = function () {
        this.props.engine.navigate("additionalCarDetails", false);
    };
    __decorate([
        (0, core_1.lazyInject)(plugin_journey_1.Types.LookupService),
        __metadata("design:type", Object)
    ], TierSummaryWidget.prototype, "lookupService", void 0);
    return TierSummaryWidget;
}(plugin_journey_1.WidgetBase));
//# sourceMappingURL=TierSummaryWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/motor/TierSummaryWidget.js
// module id = 3225
// module chunks = 0